// * Master File for site JS * //
// This file should just be used to call functions - keep site related code to a minimum here 

//Utilities
import './utilities/barbaControl';
import './utilities/hoverVideo';
import './utilities/initJS';
import './utilities/inlineVideo';
import './utilities/popups';
import './utilities/urlParams';
import './utilities/utilities';

//Components
import './components/header';

//Modules
//import './modules/example';

//Pages
import './pages/home';




// Import main scss file here. This will compile to a css file in the dist folder
import '../scss/style.scss';